import { render, staticRenderFns } from "./FaceVerificationPage2.vue?vue&type=template&id=6deea671&scoped=true"
import script from "./FaceVerificationPage2.vue?vue&type=script&lang=js"
export * from "./FaceVerificationPage2.vue?vue&type=script&lang=js"
import style0 from "./FaceVerificationPage2.vue?vue&type=style&index=0&id=6deea671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deea671",
  null
  
)

export default component.exports